// Fix for accessibility issues. Issue # VII26-08
import { getSchemeDocumentUrl } from "../../utils/util";
import React, { useEffect, useState } from "react";
// import { BsDownload } from "react-icons/bs";
import { BsEye } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader";
import { alertDanger } from "../../context/actions/toastAction";
const SchemeDocuments = ({selectedSchemeOptions=[],footer=true}) => {
  const investorInfo=useSelector(state=>state.investorInfo)

const [documents,setDocuments]=useState([])
  const [isLoading,setIsLoading]=useState(false)
  const dispatch=useDispatch()
useEffect(() => {
  if (
    selectedSchemeOptions &&
    selectedSchemeOptions.length > 0 &&
    investorInfo &&
    investorInfo?.schemes &&
    investorInfo?.schemes.length > 0
  ) {
    const schemeName = selectedSchemeOptions[0]?.split("-")[0];
    const schemeClass = selectedSchemeOptions[0]?.split("-")[1];

    // Filter schemes matching schemeName and schemeClass
    const innerBlockSchemeDetails = investorInfo?.schemes
      ?.filter(
        (scheme) =>
          scheme.scheme_name === schemeName &&
          scheme.scheme_class === schemeClass
      )
      ?.flatMap((scheme) => scheme?.documents || []); // Flatten all documents into a single array

    console.log("innerBlockSchemeDetails", innerBlockSchemeDetails);

    // Map documents into the desired structure
    const innerBlockDocuments =
      innerBlockSchemeDetails?.map((document) => ({
        scheme_name:schemeName,
        scheme_class: schemeClass,
        name: document.name,
        url: document.url,
        file_name:document.file_name,
        type: document.type?.split("/")[1], // Ensure type exists before splitting
      })) || [];

    console.log("innerBlockDocuments", innerBlockDocuments);

    // Update state based on documents
    setDocuments(innerBlockDocuments.length > 0 ? innerBlockDocuments : []);
    console.log("setDocuments(innerBlockDocuments)", innerBlockDocuments);
  }
}, [selectedSchemeOptions, investorInfo]);

 

  if(documents?.length>0){
    console.log("documents",documents)
  }

  // [
  //   { name: "SID - HDFC Defence Fund dated October 30, 2023", type: "pdf" },
  //   { name: "Presentation - HDFC Defence Fund", type: "pdf" },
  //   { name: "Fund Facts - HDFC Defence Fund", type: "pdf" },

  //   { name: "KIM - HDFC Defence Fund dated October 30, 2023", type: "pdf" },
  //   { name: "Leaflet - HDFC Defence Fund", type: "pdf" },
  //   { name: "Leaflet - HDFC Defence Fund", type: "pdf" },
  //   { name: "Leaflet - HDFC Defence Fund", type: "pdf" },
  //   { name: "Leaflet - HDFC Defence Fund", type: "pdf" },
  // ];


  const handleInvestorSchemeDocumentView = async (doc) => {
    setIsLoading(true)
    try {
      // Check if the report URL is valid before opening
      if (doc?.url) {
        const payload={
          storedSignedUrl:doc?.url,
         
         fileName:doc?.file_name,
        
       }
         const schemeDocumentURL=await getSchemeDocumentUrl(payload)
                  if(schemeDocumentURL?.code===200)
                  {
                    setTimeout(() => {
                      
                      setIsLoading(false)
                    }, 1000);
                    console.log("URL",schemeDocumentURL)
                    const url=schemeDocumentURL?.data.URL
                    window.open(url, "_blank");

                  }
                  else{
                    setTimeout(() => {
                      
                      setIsLoading(false)
                    }, 1000);
                     dispatch(alertDanger(schemeDocumentURL.message))
                  }
        
      } else {
        console.log("Invalid report URL");
        setTimeout(() => {
                      
          setIsLoading(false)
        }, 1000);
        dispatch(alertDanger("Internal server error"))
      }
      
    } catch (error) {
      console.log("Error in handleSchemeReportView function", error);
      setTimeout(() => {
                      
        setIsLoading(false)
      }, 1000);
      dispatch(alertDanger("Internal server error"))
    }
  };

  
  


  return (
    <div className="bg-white ">
         {
        isLoading && <Loader/>
      }
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {documents.length > 0 ? `${documents.length} scheme documents available` : "No scheme documents available"}
      </div>
      <h2 className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-12">
        Scheme Documents
      </h2>
 
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-24">
      
        <div className="space-y-4">
          {documents && documents?.length>0 &&  documents?.slice(0, 4).map((doc, index) => (
            <div key={index} className="flex items-center space-x-2 ">
              <div className="rounded-full bg-gray-300 p-2 text-blue-900 ">
                <BsEye  onClick={()=>handleInvestorSchemeDocumentView(doc.url)} />{" "}
              </div>
              <span className="text-sm">{doc.name}</span>
            </div>
          ))}
        </div>

        <div className="space-y-4">
          { documents && documents.length>0 && documents?.slice(4).map((doc, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div className="rounded-full bg-gray-300 p-2 text-blue-900 ">
                <BsEye onClick={()=>handleInvestorSchemeDocumentView(doc.url)}  />{" "}
              </div>
              <span className="text-sm ">{doc.name}</span>
            </div>
          ))}
        </div>
      </div> */}

<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
  {/* Partition the documents into two groups */}
  {documents && documents.length > 0 ? (() => {
    const mid = Math.ceil(documents.length / 2); // Calculate midpoint
    const leftDocuments = documents.slice(0, mid); // First half
    const rightDocuments = documents.slice(mid); // Second half

    return (
      <>
        {/* Left Column */}
        <ul className="space-y-4" aria-label="Scheme documents list">
          {leftDocuments.map((doc, index) => (
            <li key={index} className="flex items-start gap-2 flex-wrap md:flex-nowrap">
              <button
                type="button"
                onClick={() => handleInvestorSchemeDocumentView(doc)}
                className="rounded-full bg-gray-300 h-11 w-11 flex-shrink-0 items-center justify-center text-blue-900 focus:outline-none focus:ring-2 focus:ring-black"
                aria-label={`View document ${doc.name}`}
              >
                <BsEye aria-hidden="true" />
              </button>
              <span className="text-sm break-words leading-5">{doc.name}</span>
            </li>
          ))}
        </ul>

        {/* Right Column */}
        <ul className="space-y-4" aria-label="Scheme documents list">
          {rightDocuments.map((doc, index) => (
            <li key={index} className="flex items-start gap-2 flex-wrap md:flex-nowrap">
              <button
                type="button"
                onClick={() => handleInvestorSchemeDocumentView(doc)}
                className="rounded-full bg-gray-300 h-11 w-11 flex-shrink-0 items-center justify-center text-blue-900 focus:outline-none focus:ring-2 focus:ring-black"
                aria-label={`View document ${doc.name}`}
              >
                <BsEye aria-hidden="true" />
              </button>
              <span className="text-sm break-words leading-5">{doc.name}</span>
            </li>
          ))}
        </ul>
      </>
    );
  })() : (
    <div className="rounded-lg border border-dashed border-slate-400 bg-slate-50 p-6 text-center" role="status" aria-live="polite">
      <p className="text-xl font-semibold text-slate-900">No documents available</p>
      <p className="mt-2 text-sm text-slate-600">
        There are no documents for {selectedSchemeOptions[0] || "the selected scheme"} at the moment.
      </p>
    </div>
  )}
</div>


      {/* Scheme Document Formats */}
   
      { footer && <p className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2">Note: Please reach out to us at <a href="mailto:vasuki.compliance@vasukiindia.com" className="text-blue-700 underline font-normal" aria-label="Email Vasuki Compliance">vasuki.compliance@vasukiindia.com</a> for more details
        </p>}
      <p  className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2" ></p>
    </div>
  );
};

export default SchemeDocuments;
